var PlaceType;
(function (PlaceType) {
    PlaceType["country"] = "country";
    PlaceType["region"] = "region";
    PlaceType["district"] = "district";
    PlaceType["place"] = "place";
    PlaceType["locality"] = "locality";
    PlaceType["neighborhood"] = "neighborhood";
    PlaceType["address"] = "address";
})(PlaceType || (PlaceType = {}));
class GeocoderAddress {
    constructor(data) {
        this.address = {
            country: '',
            region: '',
            district: '',
            place: '',
            locality: '',
            neighborhood: '',
            address: '',
        };
        this.data = data;
        this.toAddress();
    }
    toAddress() {
        const feature = this.data.features[0];
        if (!feature)
            return;
        const placeType = feature.place_type[0];
        this.address[placeType] = feature.text;
        feature.context.forEach(({ id, text }) => {
            const [contextType] = id.split('.');
            this.address[contextType] = text;
        });
    }
}
export default class Geocoder {
    constructor({ accessToken }) {
        this.baseEndpoint = 'https://api.mapbox.com/geocoding/v5/mapbox.places/';
        this.accessToken = accessToken;
    }
    async get(url, params = {}) {
        const requestParams = {
            ...params,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            access_token: this.accessToken,
        };
        const queryString = '?' +
            Object.entries(requestParams)
                .map(([key, value]) => `${key}=${value}`)
                .join('&');
        try {
            const response = await fetch(`${this.baseEndpoint}${url}${queryString}`);
            if (!response.ok) {
                throw new Error('The api call did not succeed');
            }
            return await response.json();
        }
        catch (e) {
            console.log('error: ', e);
            return;
        }
    }
    async reverseLookup(long, lat) {
        const data = await this.get(`${long},${lat}.json`, {
            types: 'country,region,postcode,district,place,locality,neighborhood,address',
        });
        if (!data)
            return;
        const address = new GeocoderAddress(data);
        return address.address;
    }
}
